import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { date: String }

  markAsReceived() {
    const confirmed = confirm(
      "¿Confirmar que todas las ventas del día en efectivo se marcarán como recibidas? Esta acción es irreversible."
    )

    if (!confirmed) {
      return
    }

    // La fecha es la del día que muestra la pantalla, calculada por el servidor en
    // hora de Argentina. No calcularla acá con toISOString(): da la fecha en UTC, y
    // desde las 21:00 ya es el día siguiente, así que no se marcaba nada.
    const date = this.dateValue

    // Obtener CSRF token
    const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content')

    // Hacer POST request
    fetch('/sales/mark_cash_received', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': csrfToken,
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        date: date
      })
    })
    .then(response => response.json())
    .then(data => {
      if (data.success) {
        // Recargar página para mostrar cambios
        window.location.reload()
      } else {
        alert('Error: ' + data.message)
      }
    })
    .catch(error => {
      console.error('Error:', error)
      alert('Error al marcar como recibido. Por favor, intente nuevamente.')
    })
  }
}
